import React, { useMemo, useState, useEffect } from 'react';
import { UserRoles } from '../../../../../constants/index.jsx';
import {
  Button,
  useModal
} from '@gsa/afp-component-library';
import { RequisitionStatus } from '../../../../ReviewDetails/RequisitionDetailsUtils.jsx';
import { formatCurrency } from '../../../../../components/AddOptions/AddOptionsUtils.jsx';
import AttachmentDownload from '../../../../ReviewDetails/Attachment/AttachmentDownload/AttachmentDownload.jsx';
import TechnicalEvaluationForm from '../../../../../components/TechnicalEvaluationForm/TechnicalEvaluationForm.jsx';
import TechnicalEvaluationReadOnly
  from '../../../../../components/TechnicalEvaluationReadOnly/TechnicalEvaluationReadOnly.jsx';
import VendorQuoteApproved from '../../../../../components/VendorQuoteApproved/VendorQuoteApproved.jsx';
import OptionsUnavailableModal from '../../../../leasing/steps/compare-and-select/total-selling-price-leasing/option-unavailable-modal.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { setAreqVendorQuotes, setSelectedContract, setSelectedVendorQuote, setUnavailableLeasingOptions } from '../../../../../reducers/leasing.jsx';
import FundingModal from '../../compare-and-select/total-selling-price-leasing/funding-modal.jsx';
import { useGetColors, useGetFundingAvailability } from '@/requests/leasing';
import useUpdateDraft from '../../../components/update-draft/update-leasing-draft.js';
import { LeasingSteps } from '../../../leasing-consts.js';

const FINAL_QUOTE_STATUSES = [
  RequisitionStatus.PENDING_CUSTOMER_RESPONSE,
  RequisitionStatus.FINAL_APPROVAL,
  RequisitionStatus.ORDERING_ADMIN_APPROVAL,
];
const StackedColumn = ({ label, value }) => (
  <div>
    <div>{label}</div>
    <div>{value}</div>
  </div>
);
const SupportingDocument = ({ document }) => {
  const { description, name, metadataId } = document.requisitionAttachment;
  return (
    <div className="supporting-document">
      <div>
        <AttachmentDownload name={name} metadataId={metadataId} />
      </div>
      <div>{description}</div>
    </div>
  );
};
export const LeasingAreqVendorAcceptance = ({
  vendorQuote,
  index,
  status,
  lowestPrice,
}) => {
  const dispatch = useDispatch();

  const displayUnavailableModal = useModal();
  const {
    vendorName,
    makeCode,
    modelCode,
    totalPrice,
    quoteAttachment,
    contractingOfficerComments,
    extendedShippingDays,
    additionalShippingDays,
    baseShippingDays,
    supportingDocuments = [],
  } = vendorQuote;
  const selectedVendorQuote = useSelector((state) => state.leasingReducer.selectedVendorQuote);
  const unavailableLeasingOptions = useSelector((state) => state.leasingReducer.unavailableLeasingOptions);
  const isAreq = useSelector((state) => state.leasingReducer.isAreq);
  const account = useSelector((state) => state.leasingReducer.account);
  const vehiclePurchaseType = useSelector((state) => state.leasingReducer.vehiclePurchaseType);
  const selectedOptions = useSelector((state) => state.leasingReducer?.compareSelect?.selectedOptions);
  const displayFundingModal = useModal();
  const [insufficientAFVFunds, setInsufficientAFVFunds] = useState(false);
  const [unavailableOptions, setUnavailableOptions] = useState([]);
  const [currentAvailableAFVFunds, setCurrentAvailableAFVFunds] = useState(0.0);
  const [getLeasingAvailability, { loading }] = useGetFundingAvailability();
  const [updateDraft] = useUpdateDraft();

  const { name, metadataId } = quoteAttachment || {};
  const priceTitle = FINAL_QUOTE_STATUSES.includes(status)
    ? 'Total selling price (with AREQ and fees)'
    : 'AREQ price per vehicle';

  const price = FINAL_QUOTE_STATUSES.includes(status)
    ? vendorQuote?.totalPrice
    : vendorQuote?.areqPrice;
  let vendorTitle;
  if (selectedVendorQuote) {
    vendorTitle = 'Selected vendor'
  } else {
    vendorTitle = `Vendor ${index + 1}`
  }

  const handleSelectedVendor = async () => {
    const agencyIndicator =
      account?.customer?.customerBureau?.agencyIndicatorCode === null ||
        account?.customer?.customerBureau?.agencyIndicatorCode === ''
        ? 'N/A'
        : account?.customer?.customerBureau?.agencyIndicatorCode;
    const res = await getLeasingAvailability({
      variables: {
        agencyCode: account?.customer?.customerAgency?.id,
        agencyIndicator: agencyIndicator ? agencyIndicator : 'N/A',
        vehiclePurchaseType,
      },
    });
    const hasSufficientAFVFunds =
      vendorQuote?.afvTotal * vendorQuote?.quantity === 0 ||
      res?.data?.currentAvailableAFVFunds >=
      vendorQuote?.afvTotal * vendorQuote?.quantity;
    setInsufficientAFVFunds(!hasSufficientAFVFunds);
    setCurrentAvailableAFVFunds(res?.data?.currentAvailableAFVFunds);
    if (
      res?.data?.currentAvailableFunds >
      price &&
      hasSufficientAFVFunds
    ) {
      if(isAreq) {
      const unavailableLeasingOpt = [];
      for (let selected of [...vendorQuote?.perVehicleOptions, ...vendorQuote?.perOrderOptions]) {

        const option = vendorQuote.availableContractOptions.find((option) => selected.optionCode === option.equipmentCode && !option.isLeaseAvailable);
        if (option) {
          unavailableLeasingOpt.push(selected);
        }
      }
      dispatch(setUnavailableLeasingOptions([...unavailableLeasingOpt]));
      if (unavailableLeasingOpt.length > 0) {
        return displayUnavailableModal.openModal();
      }

      }
      dispatch(setSelectedVendorQuote(vendorQuote));
      const input = {
        clientData: {
          clientState: {
            selectedContract: vendorQuote
          }
        }
      }
      updateDraft(input, LeasingSteps.REVIEW_SUBMIT, null).then((data) => {
        if (data)
          dispatch(setSelectedContract(vendorQuote));
      });
    } else {
      displayFundingModal.openModal();
    }
  };
  return (<>
    <div className="title-container">
      <div className="vendor-title">{vendorTitle}</div>
      {!selectedVendorQuote &&
        lowestPrice === totalPrice && (
          <div className="lowest-bid">Lowest Bid</div>
        )}
      {
        (selectedVendorQuote ? (
          <Button
            variant="unstyled"
            type="button"
            leftIcon={{ name: 'undo' }}
            className="select-vendor-button"
            onClick={() => {
              dispatch(setSelectedVendorQuote(null))
              dispatch(setUnavailableLeasingOptions([]));
            }}
            label="Choose a different vendor"
          />
        ) : (
          <Button
            type="button"
            rightIcon={{ name: 'arrow_forward' }}
            className="select-vendor-button"
            onClick={() => {
              handleSelectedVendor();
            }}
            label="Select vendor and complete requisition"
          />
        ))}
    </div>

    <div className="vendor-quote-content">
      <div className="info-bar">
        <StackedColumn label="Vendor" value={vendorName} />
        <StackedColumn
          label="Make & model"
          value={`${makeCode}/${modelCode}`}
        />
        <StackedColumn label={priceTitle} value={formatCurrency(price)} />
      </div>
      <div className="vendor-quote">
        <div className="title">Vendor Quote</div>
        <div className="doc-link">
          <AttachmentDownload name={name} metadataId={metadataId} />
        </div>
      </div>
      <div className="co-comments">
        <div className="title">Contracting Officer&apos;s comments</div>
        <div>{contractingOfficerComments}</div>
      </div>
      <div className="co-comments">
        <div className="title">Shipping Days</div>
        <div className="shipping-data-section">
          <div>Base:</div>
          <div>{baseShippingDays}</div>
        </div>
        <div className="shipping-data-section">
          <div>Additional:</div>
          <div>{additionalShippingDays}</div>
        </div>
        <div className="shipping-data-section">
          <div>Extended:</div>
          <div>{extendedShippingDays}</div>
        </div>
        <div className="shipping-data-section shipping-total">
          <div>Total:</div>
          <div>
            {baseShippingDays + additionalShippingDays + extendedShippingDays}
          </div>
        </div>
      </div>
      <div className="supporting-documents">
        <div className="title">Supporting documents</div>
        {supportingDocuments.map((document) => (
          <SupportingDocument
            document={document}
            key={document.supportingDocumentId}
          />
        ))}
      </div>
      {selectedVendorQuote ? (<TechnicalEvaluationReadOnly vendorQuote={selectedVendorQuote} />) : (<VendorQuoteApproved vendorQuote={vendorQuote} />)}

    </div>
    <FundingModal
      isOpen={displayFundingModal.isOpen}
      handleClose={() => displayFundingModal.closeModal()}
      isInsufficientAFV={insufficientAFVFunds}
      remainingAFVFunding={currentAvailableAFVFunds}
    />

    <OptionsUnavailableModal
      isOpen={displayUnavailableModal.isOpen}
      handleClose={() => displayUnavailableModal.closeModal()}
      unavailableOptions={unavailableLeasingOptions}
      unavailableMessage="Vendor cannot be selected because following selected options are no longer available for leasing"
    />
  </>)
}